















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: ['propertyName'],
  data(): {
    chartWidth: number;
    chartHeight: number;
  } {
    return {
      chartWidth: 100,
      chartHeight: 100,
    };
  },
  computed: {
    chartOptions(): ApexOptions {
      return {
        plotOptions: {
          pie: {
            expandOnClick: true,
            donut: {
              size: '0%',
            },
          },
        },
        labels: this.categories,
        legend: {
          customLegendItems: this.legendLabels,
          width: 100,
        },
        chart: {
          toolbar: {
            show: true,
          },
          redrawOnParentResize: true,
        },
      };
    },
    classCounts(): any {
      return this.$store.getters.labelAnalysisResult[this.propertyName]
        .class_counts;
    },
    donutSeries(): string[] {
      return Object.values(this.classCounts);
    },
    categories(): string[] {
      return Object.keys(this.classCounts);
    },
    legendLabels(): string[] {
      // get sum of donutSeries
      let sum = 0;
      for (let i = 0; i < this.donutSeries.length; i++) {
        sum += parseInt(this.donutSeries[i]);
      }
      // get percentage of each donutSeries
      let percentage = [];
      for (let i = 0; i < this.donutSeries.length; i++) {
        percentage.push(
          ((parseInt(this.donutSeries[i]) / sum) * 100).toFixed(2) + '%',
        );
      }
      // get legend labels
      let legendLabels = [];
      for (let i = 0; i < this.categories.length; i++) {
        legendLabels.push(this.categories[i] + ' ' + percentage[i]);
      }
      return legendLabels;
    },
  },
  methods: {},
});
